// import React, { useState } from 'react';
// import '../index.css';
// import logo from '../assets/rem-logo.png';

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const onToggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen); // Toggle the menu state
//   };

//   return (
//     <div>
//       <header className="bg-white shadow-lg shadow-gray-300 rounded-md p-4">
//         <nav className="flex justify-between items-center w-[92%] mx-auto">
//           <div>
//             <img src={logo} alt="REM Logo" className="w-50 h-16 bg-purple-800 rounded-xl" />
//           </div>
//           <div
//             className={`nav-links duration-500 md:static absolute bg-white md:min-h-fit min-h-[60vh] left-0 ${
//               isMenuOpen ? 'top-[15%]' : 'top-[-100%]'
//             } md:w-auto w-full flex items-center px-5`}
//           >
//             <ul className="flex md:flex-row flex-col md:items-center md:gap-[3vw] gap-5 ">
//               <li>
//                 <a className= "font-medium text-lg hover:text-gray-600" href="/">
//                 HOME
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="/About">
//                 ABOUT
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="/AllServices">
//                 SERVICES
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="/Faqs">
//                 WHY US?
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="Careers">
//                 CAREERS
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="/Gallery">
//                 GALLERY
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600" href="/OurClients">
//                 CLIENTS
//                 </a>
//               </li>
//             </ul>
//           </div>
//           <div className="flex items-center gap-6">
//             <button href="/Contact" className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium">
//               <a href="/Contact">Contact Us!</a>
//             </button>
//             <ion-icon
//               name={isMenuOpen ? 'close' : 'menu'}
//               class="text-3xl cursor-pointer md:hidden"
//               onClick={onToggleMenu}
//             ></ion-icon>
//           </div>
//         </nav>
//       </header>
//     </div>
//   );
// };

// export default Navbar;











// import React, { useState, useEffect } from 'react';
// import '../index.css';
// import logo from '../assets/rem-logo.png';
// import { FaSun, FaMoon } from 'react-icons/fa';
// import { motion, useSpring, useScroll } from "motion/react";

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light'); // Get theme from localStorage

//   // Toggle dark/light theme
//   const toggleTheme = () => {
//     const newTheme = theme === 'light' ? 'dark' : 'light';
//     setTheme(newTheme);
//     localStorage.setItem('theme', newTheme); // Save theme to localStorage
//   };

//   // Apply theme to document body
//   useEffect(() => {
//     document.documentElement.classList.remove(theme === 'light' ? 'dark' : 'light');
//     document.documentElement.classList.add(theme);
//   }, [theme]);

//   const onToggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen); // Toggle the menu state
//   };

//   const { scrollYProgress } = useScroll();

//   return (
//     <div className=' z-50'>

//       <motion.div
//         className="h-[6.5px] bg-purple-800 origin-[0%] fixed top-0 left-0 right-0 z-50"
//         style={{ scaleX: scrollYProgress }}
//       />

//       <header className=" bg-white shadow-lg shadow-gray-300 rounded-md p-4 dark:bg-black">
//         <nav className="flex justify-between items-center w-[92%] mx-auto">
//           <div>
//             <img src={logo} alt="REM Logo" className="w-50 h-16 bg-purple-800 rounded-xl" />
//           </div>
//           <div
//             className={`nav-links duration-500 md:static absolute bg-white dark:bg-black md:min-h-fit min-h-[60vh] left-0 ${isMenuOpen ? 'top-[15%]' : 'top-[-100%]'
//               } md:w-auto w-full flex items-center px-5`}
//           >
//             <ul className="flex md:flex-row flex-col md:items-center md:gap-[3vw] gap-5">
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/">
//                   HOME
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/About">
//                   ABOUT
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/AllServices">
//                   SERVICES
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/Faqs">
//                   WHY US?
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="Careers">
//                   CAREERS
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/Gallery">
//                   GALLERY
//                 </a>
//               </li>
//               <li>
//                 <a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/OurClients">
//                   CLIENTS
//                 </a>
//               </li>
//             </ul>
//           </div>
//           <div className="flex items-center gap-6">
//             <button
//               href="/Contact"
//               className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium dark:bg-blue-700 dark:hover:bg-blue-600"
//             >
//               <a href="/Contact">Contact Us!</a>
//             </button>

//             {/* Theme toggle button */}
//             <button
//               onClick={toggleTheme}
//               className="p-2 rounded-full bg-purple-400 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500"
//             >
//               {theme === 'light' ? (
//                 <FaMoon className="text-xl text-gray-700 dark:text-gray-200" />
//               ) : (
//                 <FaSun className="text-xl text-yellow-400" />
//               )}
//             </button>

//             <ion-icon
//               name={isMenuOpen ? 'close' : 'menu'}
//               class="text-3xl cursor-pointer md:hidden dark:text-white"
//               onClick={onToggleMenu}
//             ></ion-icon>
//           </div>
//         </nav>
//       </header>
//     </div>
//   );
// };

// export default Navbar;







//import React, { useState, useEffect } from 'react';
// import '../index.css';
// import logo from '../assets/rem-logo.png';
// import { FaSun, FaMoon } from 'react-icons/fa';
// import { mo tion, useSpring, useScroll } from "motion/react";

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light'); // Get theme from localStorage

//   // Toggle dark/light theme
//   const toggleTheme = () => {
//     const newTheme = theme === 'light' ? 'dark' : 'light';
//     setTheme(newTheme);
//     localStorage.setItem('theme', newTheme); // Save theme to localStorage
//   };

//   // Apply theme to document body
//   useEffect(() => {
//     document.documentElement.classList.remove(theme === 'light' ? 'dark' : 'light');
//     document.documentElement.classList.add(theme);
//   }, [theme]);

//   const onToggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen); // Toggle the menu state
//   };

//   const { scrollYProgress } = useScroll();

//   return (
//     <div className='pt-[80px]'>  {/* Prevents content from being hidden behind fixed navbar */}
      
//       {/* Scroll progress bar */}
//       <motion.div
//         className="h-[6.5px] bg-purple-800 origin-[0%] fixed top-0 left-0 right-0 z-50"
//         style={{ scaleX: scrollYProgress }}
//       />

//       {/* Sticky Navbar */}
//       <header className="fixed top-0 w-full z-50 bg-white shadow-lg shadow-gray-300 rounded-md p-4 dark:bg-black">
//         <nav className="flex justify-between items-center w-[92%] mx-auto">
//           <div>
//             <img src={logo} alt="REM Logo" className="w-50 h-16 bg-purple-800 rounded-xl" />
//           </div>
//           <div
//             className={`nav-links duration-500 md:static absolute bg-white dark:bg-black md:min-h-fit min-h-[60vh] left-0 ${
//               isMenuOpen ? 'top-[15%]' : 'top-[-100%]'
//             } md:w-auto w-full flex items-center px-5`}
//           >
//             <ul className="flex md:flex-row flex-col md:items-center md:gap-[3vw] gap-5">
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/">HOME</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/About">ABOUT</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/AllServices">SERVICES</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/Faqs">WHY US?</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/Careers">CAREERS</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/Gallery">GALLERY</a></li>
//               <li><a className="font-medium text-lg hover:text-gray-600 dark:text-white" href="/OurClients">CLIENTS</a></li>
//             </ul>
//           </div>
//           <div className="flex items-center gap-6">
//             <button className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium dark:bg-blue-700 dark:hover:bg-blue-600">
//               <a href="/Contact">Contact Us!</a>
//             </button>

//             {/* Theme toggle button */}
//             <button
//               onClick={toggleTheme}
//               className="p-2 rounded-full bg-purple-400 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500"
//             >
//               {theme === 'light' ? (
//                 <FaMoon className="text-xl text-gray-700 dark:text-gray-200" />
//               ) : (
//                 <FaSun className="text-xl text-yellow-400" />
//               )}
//             </button>

//             <ion-icon
//               name={isMenuOpen ? 'close' : 'menu'}
//               class="text-3xl cursor-pointer md:hidden dark:text-white"
//               onClick={onToggleMenu}
//             ></ion-icon>
//           </div>
//         </nav>
//       </header>
//     </div>
//   );
// };

// export default Navbar;






// // import React, { useState, useEffect } from 'react';
// // import { motion, useScroll } from 'framer-motion';
// import { MoonIcon, SunIcon, Bars3Icon as MenuIcon, XMarkIcon as XIcon } from '@heroicons/react/24/outline';
// // import profileImage from '../assets/images/profile.jpg';

// import React, { useState, useEffect } from 'react';
// import '../index.css';
// import logo from '../assets/logo.png';
// import { FaSun, FaMoon } from 'react-icons/fa';
// import { motion, useSpring, useScroll } from "motion/react";
// import { Link } from 'react-router-dom';

// const Navbar = () => {
//   const [isDark, setIsDark] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const { scrollYProgress } = useScroll();

//   useEffect(() => {
//     if (isDark) {
//       document.documentElement.classList.add('dark');
//     } else {
//       document.documentElement.classList.remove('dark');
//     }
//   }, [isDark]);

//   const navItems = [
//     { name: 'Home', href: '/' },
//     { name: 'About', href: '/About' },
//     { name: 'Services', href: '/AllServices' },
//     { name: 'Why Us?', href: '/Faqs' },
//     { name: 'Career', href: '/Careers' },
//     { name: 'Gallery', href: '/Gallery' },
//     { 
//       name: 'OurClients', 
//       href: '/OurClients',
       
//     },
//     { name: 'Contact Us!', href: '/Contact',special: true },
    
//   ];

//   return (
//     <nav className=" fixed top-0 left-0 right-0 bg-white/80 dark:bg-dark-950/80 backdrop-blur-sm shadow-lg z-50">
//       {/* Scroll progress bar */}
//        <motion.div
//         className="h-[6.5px] bg-purple-800 origin-[0%] fixed top-0 left-0 right-0 z-50"
//         style={{ scaleX: scrollYProgress }}
//       />
//       <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-between h-16">
//           <div className="flex items-center">
//             <a href="#home" className="flex items-center space-x-2 font-bold whitespace-nowrap">
//               <img 
//                 src={logo} 
//                 alt="Profile" 
//                 className="bg-purple-600 w-10 h-10 rounded-full object-cover"
//               />
//               <span className="text-purple-800  bg-clip-text font-bold text-xl">
//                 Powergenic
//               </span>
//             </a>
//           </div>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center justify-end flex-1 ml-4">
//             <div className="flex items-center space-x-1 lg:space-x-2">
//               {navItems.map((item) => (
//                 <a
//                   key={item.name}
//                   href={`${item.href}`}
//                   className={`px-2 lg:px-3 py-2 text-sm lg:text-base ${
//                     item.special 
//                       ? 'text-white bg-purple-700 hover:from-primary-700 hover:to-secondary-700 rounded-full font-medium shadow-lg hover:shadow-primary-500/25'
//                       : 'text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400'
//                   } transition-all duration-200 whitespace-nowrap`}
//                 >
//                   {item.name}
//                 </a>
//               ))}
//               <button
//                 onClick={() => setIsDark(!isDark)}
//                 className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 ml-1"
//               >
//                 {isDark ? (
//                   <SunIcon className="h-6 w-6" />
//                 ) : (
//                   <MoonIcon className="h-6 w-6" />
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Mobile Navigation Button */}
//           <div className="flex md:hidden items-center space-x-2">
//             <button
//               onClick={() => setIsDark(!isDark)}
//               className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400"
//             >
//               {isDark ? (
//                 <SunIcon className="h-6 w-6" />
//               ) : (
//                 <MoonIcon className="h-6 w-6" />
//               )}
//             </button>
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400"
//             >
//               {isMenuOpen ? (
//                 <XIcon className="h-6 w-6" />
//               ) : (
//                 <MenuIcon className="h-6 w-6" />
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Navigation Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden">
//           <div className="px-2 pt-2 pb-3 space-y-1">
//             {navItems.map((item) => (
//               <a
//                 key={item.name}
//                 href={`#${item.href}`}
//                 className={`block px-3 py-2 ${
//                   item.special 
//                     ? 'text-white bg-purple-700 hover:from-primary-700 hover:to-secondary-700 rounded-full font-medium'
//                     : 'text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400'
//                 }`}
//                 onClick={() => setIsMenuOpen(false)}
//               >
//                 {item.name}
//               </a>
//             ))}
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;




import React, { useState, useEffect } from 'react';
import '../index.css';
import logo from '../assets/logo.png';
import { FaSun, FaMoon } from 'react-icons/fa';
import { motion, useScroll } from "motion/react";
import { Link } from 'react-router-dom'; // Ensure Link is imported from react-router-dom
import { MoonIcon, SunIcon, Bars3Icon as MenuIcon, XMarkIcon as XIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
  const [isDark, setIsDark] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/About' },
    { name: 'Services', href: '/AllServices' },
    { name: 'Why Us?', href: '/Faqs' },
    { name: 'Career', href: '/Careers' },
    { name: 'Gallery', href: '/Gallery' },
    { name: 'OurClients', href: '/OurClients' },
    { name: 'Contact Us!', href: '/Contact', special: true },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/80 dark:bg-dark-950/80 backdrop-blur-sm shadow-lg z-50">
      {/* Scroll progress bar */}
      <motion.div
        className="h-[6.5px] bg-purple-800 origin-[0%] fixed top-0 left-0 right-0 z-50"
        style={{ scaleX: scrollYProgress }}
      />
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2 font-bold whitespace-nowrap">
              <img 
                src={logo} 
                alt="Profile" 
                className="bg-purple-600 w-10 h-10 rounded-full object-cover"
              />
              <span className="text-purple-800  bg-clip-text font-bold text-xl">
                Powergenic
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center justify-end flex-1 ml-4">
            <div className="flex items-center space-x-1 lg:space-x-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href} // Use 'to' for navigation within the app
                  className={`px-2 lg:px-3 py-2 text-sm lg:text-base ${
                    item.special 
                      ? 'text-white bg-purple-700 hover:from-primary-700 hover:to-secondary-700 rounded-full font-medium shadow-lg hover:shadow-primary-500/25'
                      : 'text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400'
                  } transition-all duration-200 whitespace-nowrap`}
                >
                  {item.name}
                </Link>
              ))}
              <button
                onClick={() => setIsDark(!isDark)}
                className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 ml-1"
              >
                {isDark ? (
                  <SunIcon className="h-6 w-6" />
                ) : (
                  <MoonIcon className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation Button */}
          <div className="flex md:hidden items-center space-x-2">
            <button
              onClick={() => setIsDark(!isDark)}
              className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400"
            >
              {isDark ? (
                <SunIcon className="h-6 w-6" />
              ) : (
                <MoonIcon className="h-6 w-6" />
              )}
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400"
            >
              {isMenuOpen ? (
                <XIcon className="h-6 w-6" />
              ) : (
                <MenuIcon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href} // Use 'to' for navigation within the app
                className={`block px-3 py-2 ${
                  item.special 
                    ? 'text-white bg-purple-700 hover:from-primary-700 hover:to-secondary-700 rounded-full font-medium'
                    : 'text-dark-700 dark:text-dark-300 hover:text-primary-600 dark:hover:text-primary-400'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;





